import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Route } from "react-router-dom";

import { Content, ContentPage, Kitten, Wrraper } from "./styled";
import { ManagerMenu } from "./components/manager-menu";
import { ManagerHeader } from "./components/manager-header";
import { LocationList } from "./products/location-list";
import { NewUser } from "./users/new-user";
import { UsersList } from "./users/users-list";
import { ProductManager } from "./products/products-manager";
import { CreateProduct } from "./products/create-products";
import { ProductDetails } from "./products/products-details";
import { Settings } from "./settings";
import { SupportContactManager } from "./support-contact-manager";
import { Profile } from "./profile";
import { Billing as PartnerBilling } from "./partner/billing";
import { Billing } from "./admin/billing";
import { ListWithdrawal } from "./partner/billing/withdrawal/list-withdrawal";
import { NewWithdrawal } from "./partner/billing/withdrawal/new-withdrawal";
import { Statements } from "./partner/statements";
import { Requests } from "./admin/requests/requests-list";
import { RequestDetails } from "./admin/requests/request-details";
import { UserDetail } from "./users/user-detail";
import { ManagerPartnerDashboard } from "./partner/manager-dashboard";
import { ManagerAdminDashboard } from "./admin/manager-dashboard";
import { MyCoursesList } from "./my-courses/list";
import { NewEditCourse } from "./my-courses/new-edit-course";
import { ViewCourse } from "./my-courses/view-course";
import { SyncDisciplines } from "./my-courses/sync-disciplines";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import SystemContext from "../../../context/systemContext/context";
import { Orders } from "./orders/list";
import { OrderDetails } from "./orders/details";
import { Reports } from "./reports";
import { Subscriptions } from "./subscriptions/list";
import { SubscriptionHistory } from "./subscriptions/history";
import { CreateSubscription } from "./subscriptions/new";

const Manager = (): JSX.Element => {
	const { width } = useWindowDimensions();
	const { systemConfig, update } = useContext(SystemContext);
	const [show, setShow] = useState(systemConfig.menuManagerDesktopOpen);
	const [showUserOptions, setShowUserOptions] = useState(false);

	useEffect(() => {
		if (width > 900) {
			update({ ...systemConfig, menuManagerDesktopOpen: show });
		}
	}, [show]);

	return (
		<Fragment>
			<ManagerHeader
				showUserOptions={showUserOptions}
				setShowUserOptions={setShowUserOptions}
				showMenu={show}
				setShowMenu={setShow}
			/>
			<Wrraper onClick={() => setShowUserOptions(false)}>
				<ManagerMenu
					show={show}
					setShow={setShow}
				>
					<Kitten
						id="kitten-button"
						className="kitten-button"
						show={show}
						onClick={() => {
							setShow(!show);
						}}
					>
						{show ? <FaChevronLeft /> : <FaChevronRight />}
					</Kitten>
				</ManagerMenu>
				<ContentPage
					show={show}
					onClick={() => {
						if (width < 900) setShow(false);
					}}
				>
					<Content>
						<Route
							path="/manager/admin/dashboard"
							component={ManagerAdminDashboard}
						/>
						<Route
							path="/manager/admin/billing"
							component={Billing}
						/>
						<Route
							path="/manager/admin/requests"
							component={Requests}
						/>
						<Route
							path="/manager/admin/request/:id"
							component={RequestDetails}
						/>
						<Route
							path="/manager/partner/dashboard"
							component={ManagerPartnerDashboard}
						/>
						<Route
							path="/manager/partner/billing"
							component={PartnerBilling}
						/>
						<Route
							path="/manager/partner/withdrawal"
							component={ListWithdrawal}
						/>
						<Route
							path="/manager/partner/new-withdrawal"
							component={NewWithdrawal}
						/>
						<Route
							path="/manager/partner/statements"
							component={Statements}
						/>
						<Route
							path="/manager/materials"
							component={LocationList}
						/>
						<Route
							path="/manager/users"
							component={UsersList}
						/>
						<Route
							path="/manager/user/:id"
							component={UserDetail}
						/>
						<Route
							path="/manager/add-user"
							component={NewUser}
						/>
						<Route
							path="/manager/materials-manager"
							component={ProductManager}
						/>
						<Route
							path="/manager/subscriptions/history/:id"
							component={SubscriptionHistory}
						/>
						<Route
							path="/manager/subscriptions/new"
							component={CreateSubscription}
						/>
						<Route
							path="/manager/subscriptions"
							component={Subscriptions}
							exact
						/>
						<Route
							path="/manager/add-materials"
							component={CreateProduct}
						/>
						<Route
							path="/manager/material/:topicId/:id"
							component={ProductDetails}
							exact
						/>
						<Route
							path="/manager/add-user/:id"
							component={NewUser}
						/>
						<Route
							path="/manager/settings"
							component={Settings}
						/>
						<Route
							path="/manager/my-courses"
							component={MyCoursesList}
						/>
						<Route
							path="/manager/new-course"
							component={NewEditCourse}
						/>
						<Route
							path="/manager/edit-course/:id"
							component={NewEditCourse}
						/>
						<Route
							path="/manager/view-course/:id"
							component={ViewCourse}
						/>
						<Route
							path="/manager/sync-disciplines"
							component={SyncDisciplines}
						/>
						<Route
							path="/manager/support"
							component={SupportContactManager}
						/>
						<Route
							path="/manager/profile"
							component={Profile}
						/>
						<Route
							path="/manager/orders"
							component={Orders}
						/>
						<Route
							path="/manager/order/:id"
							component={OrderDetails}
						/>
						<Route
							path="/manager/reports"
							component={Reports}
						/>
					</Content>
				</ContentPage>
			</Wrraper>
		</Fragment>
	);
};

export default {
	routeProps: {
		path: "/manager",
		component: Manager,
	},
	children: [
		"/manager/dashboard",
		"/manager/admin/dashboard",
		"/manager/admin/billing",
		"/manager/admin/requests",
		"/manager/admin/request/:id",
		"/manager/partner/dashboard",
		"/manager/partner/billing",
		"/manager/partner/withdrawal",
		"/manager/partner/new-withdrawal",
		"/manager/partner/statements",
		"/manager/users",
		"/manager/user/:id",
		"/manager/add-user",
		"/manager/materials",
		"/manager/material/:topicId/:id",
		"/manager/add-materials",
		"/manager/view-materials",
		"/manager/materials-manager",
		"/manager/subscriptions",
		"/manager/settings",
		"/manager/my-courses",
		"/manager/new-course",
		"/manager/edit-course/:id",
		"/manager/view-course/:id",
		"/manager/sync-disciplines",
		"/manager/support",
		"/manager/profile",
		"/manager/material",
		"/manager/orders",
		"/manager/order/:id",
		"/manager/reports",
	],
	name: "Manager",
};
